import { NgModule } from "@angular/core";
import { CommonModule } from "common";
import { SharedModule } from "../shared/shared.module";
import { AccountAppBarExpandedComponent } from "./account-app-bar-expanded/account-app-bar-expanded.component";
import { AccountAppBarTitleComponent } from "./account-app-bar-title/account-app-bar-title.component";
import { AccountEconomicsComponent } from "./account-economics/account-economics.component";
import { AccountListFilterDialogComponent } from "./account-list-filter-dialog/account-list-filter-dialog.component";
import { AccountListComponent } from "./account-list/account-list.component";
import { AccountRoutingModule } from "./account-routing.module";
import { AccountStatusIconChipComponent } from "./account-status-icon-chip/account-status-icon-chip.component";
import { AccountPaymentListComponent } from "./account-payment-list/account-payment-list.component";
import { AccountStateBalanceDetailsComponent } from "./account-state-balance-details/account-state-balance-details.component";
import { AccountStateWidgetComponent } from "./account-state-widget/account-state-widget.component";
import { AccountProfileComponent } from "./account-profile/account-profile.component";
import { AccountProfileCompanyInfoWidgetComponent } from "./account-profile-company-info-widget/account-profile-company-info-widget.component";
import { AccountProfileStatusWidgetComponent } from "./account-profile-status-widget/account-profile-status-widget.component";
import { AccountProfileStatusDetailsComponent } from "./account-profile-status-details/account-profile-status-details.component";
import { AccountOfferDetailsComponent } from "./account-offer-details/account-offer-details.component";
import { AccountAuditTrailComponent } from "./account-audit-trail/account-audit-trail.component";
import { CashFlowAnalysisModule } from "../shared/cash-flow-analysis/cash-flow-analysis.module";
import { ReAmortizeDialogComponent } from "./account-state-balance-details/re-amortize-dialog/re-amortize-dialog.component";
import { AccountOtherInfoDetailsComponent } from "./account-profile-other-info-details/account-profile-other-info-details.component";
import { AccountModificationListComponent } from "./account-modification-list/account-modification-list.component";
import { AccountModificationDetailsComponent } from "./account-modification-details/account-modification-details.component";
import { AccountModificationUpdateDialogComponent } from "./account-modification-update-dialog/account-modification-update-dialog.component";
import { AccountModificationIconChipComponent } from "./account-modification-icon-chip/account-modification-icon-chip.component";
import { AccountOfferUpdateDialogComponent } from "./account-offer-update-dialog/account-offer-update-dialog.component";
import { AccountStateBalanceUpdateDialogComponent } from "./account-state-balance-update-dialog/account-state-balance-update-dialog.component";
import { AccountStatusComponent } from "./account-status/account-status.component";
import { AccountLiquidityEventWidgetComponent } from './account-liquidity-event-widget/account-liquidity-event-widget.component';
import { AccountLiquidityEventAddComponent } from './account-liquidity-event-add/account-liquidity-event-add.component';
import { AccountStatementsWidgetComponent } from './account-statements-widget/account-statements-widget.component';
import { AccountStatementsEditComponent } from './account-statements-widget/components/account-statements-edit/account-statements-edit.component';
import { AccountStatementGenerationLabelPipe } from './account-statements-widget/pipes/account-statement-generation-label.pipe';
import { AccountAlligatorDataIconChipComponent } from "./account-statements-widget/components/account-alligator-data-icon-chip/account-alligator-data-icon-chip.component";
import { AlligatorDataClassPipe } from "./account-list/pipes/alligator-data-class.pipe";
import { AlligatorDataIconPipe } from "./account-list/pipes/alligator-data-icon.pipe";
import { AlligatorDataTooltipPipe } from "./account-list/pipes/alligator-data-tooltip.pipe";
import { AccountPledgeComponent } from './account-pledge/account-pledge.component';
import { AccountPledgeFilterDialogComponent } from './account-pledge/account-pledge-filter-dialog/account-pledge-filter-dialog.component';
import { AccountFacilityWidgetComponent } from "./account-facility-widget/account-facility-widget.component";
import { AccountFacilityDetailsComponent } from "./account-facility-details/account-facility-details.component";
import { AccountFacilityCardComponent } from "./account-facility-details/components/account-facility-card/account-facility-card.component";
import { AccountPledgeFailedDialogComponent } from './account-pledge/account-pledge-failed-dialog/account-pledge-failed-dialog.component';
import { FacitlityHistoryAssignementLabelPipe } from "./account.pipes";
import { AccountInterestRateChangeHistoryComponent } from './account-interest-rate-change-history/account-interest-rate-change-history.component';
import { AccountInterestRateChangeHistoryItemComponent } from './account-interest-rate-change-history/components/account-interest-rate-change-history-item/account-interest-rate-change-history-item.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    AccountRoutingModule,
    CashFlowAnalysisModule
  ],
  exports: [AccountPaymentListComponent, AccountStatusIconChipComponent],
  declarations: [
    AccountAppBarExpandedComponent,
    AccountAppBarTitleComponent,
    AccountEconomicsComponent,
    AccountListComponent,
    AccountListFilterDialogComponent,
    AccountStatusIconChipComponent,
    AccountPaymentListComponent,
    AccountStateBalanceDetailsComponent,
    AccountStateWidgetComponent,
    AccountFacilityWidgetComponent,
    AccountProfileComponent,
    AccountProfileCompanyInfoWidgetComponent,
    AccountOfferDetailsComponent,
    AccountFacilityDetailsComponent,
    AccountFacilityCardComponent,
    AccountProfileStatusWidgetComponent,
    AccountProfileStatusDetailsComponent,
    AccountAuditTrailComponent,
    ReAmortizeDialogComponent,
    AccountOtherInfoDetailsComponent,
    AccountModificationListComponent,
    AccountModificationDetailsComponent,
    AccountModificationUpdateDialogComponent,
    AccountModificationIconChipComponent,
    AccountOfferUpdateDialogComponent,
    AccountStateBalanceUpdateDialogComponent,
    AccountStatusComponent,
    AccountLiquidityEventWidgetComponent,
    AccountLiquidityEventAddComponent,
    AccountStatementsWidgetComponent,
    AccountStatementsEditComponent,
    AccountStatementGenerationLabelPipe,
    AccountAlligatorDataIconChipComponent,
    AlligatorDataClassPipe,
    AlligatorDataIconPipe,
    AlligatorDataTooltipPipe,
    AccountPledgeComponent,
    AccountPledgeFilterDialogComponent,
    FacitlityHistoryAssignementLabelPipe,
    AccountPledgeFailedDialogComponent,
    AccountInterestRateChangeHistoryComponent,
    AccountInterestRateChangeHistoryItemComponent
  ],
  providers: [AccountStatementGenerationLabelPipe]
})
export class AccountModule {}
